const useCurrentMonth = () => {
  return document.getElementById('current-month')
}

export default useCurrentMonth
